import styled from "@emotion/styled";
import * as MuiIcons from "@mui/icons-material";
import * as Mui from "@mui/material";
import { ColDef, ICellRendererParams } from "ag-grid-community";
import { customTheme } from "../../../../../config/theme/MuiTheme";
import AgGridCustomTable from "../../../../../util/component/AgGridCustomTable";
import { useAgGridCustomDatasource } from "../../../hooks/useAgGridCustomDatasource";
import useOperationTranslation from "../../../hooks/useOperationTranslation";
import Ellipsis from "../../common/Ellipsis";
import EmptyStateGrid from "../../common/EmptyStateGrid";
import { nameof } from "../../common/ObjectUtils";
import { EquipmentKitService } from "../../equipment/equipmentKit/EquipmentKitService";
import EquipmentKitTypes from "../../equipment/equipmentKit/Types";
import { EquipmentAssociationTypes } from "../Types";
import AgGridOperationTable from "../../common/AgGridOperationTable";

const StyledDialogTitle = styled(Mui.DialogTitle)({
  marginBottom: "0px !important",
})

interface Props {
  tenant:string;
  open: boolean;
  onClose: () => void;
  kit?: EquipmentAssociationTypes.Kit;
}

const WatchEquipmentKit = (props: Props) => {
  const t = useOperationTranslation();

  const [datasource, totalElements] = useAgGridCustomDatasource(
    EquipmentKitService.get.equipmentsById,
    [props.tenant,props.kit?.id],
    [props.kit]
  )

  const columns: ColDef[] = [
    {
      headerName: t("vehicleEquipmentAssociation.dialogs.watchKit.table.columns.code"),
      field: nameof<EquipmentKitTypes.IEquipmentsValid>("code"),
      flex: 1,
    },
    {
      headerName: t("vehicleEquipmentAssociation.dialogs.watchKit.table.columns.description"),
      field: nameof<EquipmentKitTypes.IEquipmentsValid>("descr"),
      flex: 1,
      cellRenderer: (params: ICellRendererParams<EquipmentKitTypes.IEquipmentsValid>) => {
        return (
          <Mui.Tooltip title={params.value}>
            <Ellipsis>
              {params.value}
            </Ellipsis>
          </Mui.Tooltip>
        );
      }
    }
  ]

  return (
    <Mui.Dialog open={props.open} onClose={props.onClose} fullWidth={true}>
      <StyledDialogTitle>
        <Mui.Grid container alignItems="center" spacing="16px">
          <Mui.Grid item xs={4}>
            <Mui.Typography variant="h5">{t("vehicleEquipmentAssociation.dialogs.watchKit.title")}</Mui.Typography>
          </Mui.Grid>

          <Mui.Grid item xs={8} ml="auto">
            <Mui.Grid container alignItems="center">
              <Mui.Grid item xs={11}>
                <Mui.Stack direction="row" alignItems="center" color={customTheme.palette.accent.main} justifyContent="end">
                  <Mui.Tooltip title={`t("vehicleEquipmentAssociation.dialogs.watchKit.subtitle") ${props.kit?.descr}`}>
                    <Ellipsis textAlign="end">
                      <Mui.Typography variant="body" color="inherit">{t("vehicleEquipmentAssociation.dialogs.watchKit.subtitle")}</Mui.Typography>
                      <Mui.Typography variant="h6" color="inherit" ml="5px">{props.kit?.descr}</Mui.Typography>
                    </Ellipsis>
                  </Mui.Tooltip>
                </Mui.Stack>
              </Mui.Grid>

              <Mui.Grid item xs={1}>
                <Mui.IconButton onClick={props.onClose}>
                  <MuiIcons.Close />
                </Mui.IconButton>
              </Mui.Grid>
            </Mui.Grid>
          </Mui.Grid>
          
          {/* <Mui.Grid item xs="auto">
          </Mui.Grid> */}
        </Mui.Grid>
      </StyledDialogTitle>

      <AgGridOperationTable
        columnDefs={columns}
        serverSideDatasource={datasource}
        serverSideInfiniteScroll={true}
        rowModelType="serverSide"
        cacheBlockSize={10}
        totalElements={totalElements}
        emptyState={{
          title: t("vehicleEquipmentAssociation.dialogs.watchKit.table.emptyState.title"),
          content: t("vehicleEquipmentAssociation.dialogs.watchKit.table.emptyState.content")
        }}
      />

    </Mui.Dialog>
  )
}

export default WatchEquipmentKit;